


import { setGetMailingStatisticsScrollerUsersWithdrawalsByUserAction } from '../action';
import { getMailingStatisticsScrollerUsersWithdrawalsByUser } from '../api/getMailingStatisticsScrollerUsersWithdrawalsByUser';

export const setGetMailingStatisticsScrollerUsersWithdrawalsByUser = (params) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await getMailingStatisticsScrollerUsersWithdrawalsByUser(params);

            const state = getState().mailing.scrollers.withdrawals_by_user;

            const new_data = {
                ...state,
                [params.login]: data
            }

            dispatch(setGetMailingStatisticsScrollerUsersWithdrawalsByUserAction(new_data))
        } catch (error) {
            alert('Ошибка')
            console.log(error)
        }
    }
}